import {OrbitUserFlowAnalyticsCategory} from "../analytics/analytics.service.interface";
import {MenuItemKey} from "../configurations/config-data-sections/generated-config-const";
import {IMenuItemActionFactoryService} from "../menu-item-action-factory/menu-item-action-factory.service.interface";
import {loadCustomMenuItemsRenderers} from "../menu-items-common/renderer/dynamic-custom-menu-item-renderers-loader";
import {IMenuItemRenderer} from "../menu-items-common/renderer/menu-item.renderer.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ServiceBase} from "../ServiceBase";
import {GenericTabsNavigationItemRenderer} from "./menu-items/generic-tabs-navigation-item.renderer";
import {TabsNavigationItemConfigReader} from "./menu-items/tabs-navigation-item-config-reader";
import {ITabsNavigationService} from "./tabs-navigation.interface";

export class TabsNavigationService extends ServiceBase implements ITabsNavigationService {
    constructor(services: IServiceFactoryExtended,
        private readonly menuItemActionFactory: IMenuItemActionFactoryService) {
        super(services);

        this._menuItemConfigReader = new TabsNavigationItemConfigReader(services);

        // When custom renderers will add - uncomment beneath lines to load them:
        // let rendererModules = require.context('./custom-renderers', true, /.+\.renderer\.(ts|tsx)$/);
        // this._customMenuItems = loadCustomMenuItemsRenderers(rendererModules.keys().map(rendererModules), this._menuItemConfigReader, this.services, this.menuItemActionFactory);

        this._customMenuItems = loadCustomMenuItemsRenderers([], this._menuItemConfigReader, this.services, this.menuItemActionFactory);
    }

    private readonly _menuItemConfigReader: TabsNavigationItemConfigReader;
    private readonly _customMenuItems: Record<MenuItemKey, IMenuItemRenderer>;


    getMenuItem(key: MenuItemKey): IMenuItemRenderer {
        let menuItemRenderer = this.services.regulation.current.menuItems.getTabsNavigationItem(key, this._menuItemConfigReader, this.menuItemActionFactory);
        if (menuItemRenderer) {
            return menuItemRenderer;
        }

        menuItemRenderer = this._customMenuItems[key];
        if (menuItemRenderer) {
            return menuItemRenderer;
        }

        return new GenericTabsNavigationItemRenderer(key, this._menuItemConfigReader, this.services, this.menuItemActionFactory);
    }

    sendOrbitUserFlowAnalytics(tabOriginalName: string, label: string): void {
        const action = 'Click_' + tabOriginalName;
        this.services.analytics.sendOrbitUserFlowEvent(OrbitUserFlowAnalyticsCategory.TabsNavigation, action, label);
    }

    get shouldRenderTabsNavigation(): boolean {
        if (!this.services.mediaQuery.lAndBelow) {
            return false;
        }

        return this.services.abTestingFeatureDataProvider.siteNewNavigation.isEnabled;
    }
}
